var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value_string)?_c('div',{staticClass:"tw-flex tw-w-full"},[(_vm.should_be_linked)?_c('h6',[_c('a',{attrs:{"href":_vm.value_string}},[_vm._v(_vm._s(_vm.value_string))])]):_c('h6',[_vm._v(_vm._s(_vm.value_string))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }